import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { Autocomplete, Box, TableFooter, TextField } from "@mui/material";
import { AppraisalAssetsModel, AppraisalsDetailsModelForEquity } from "../../../all_Interfaces";
import { useAppSelector } from "../../../redux/hooks";
import currencySymbolMap from "currency-symbol-map";
import { useEffect, useState } from "react";
import { updateAppraisalAssets } from "../../../redux/slices/AppraisalAssetsSlice";
import { useDispatch } from "react-redux";

export const AppraisalAssetsList = (props: any) => {

  const dispatch = useDispatch();
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [rows, setRows] = useState<AppraisalAssetsModel[]>([]);
  const appraisalDetails: AppraisalsDetailsModelForEquity = useAppSelector(
    (state) => state.AppraisalDetailsForUSAppraisal.data
  );

  const assets: AppraisalAssetsModel[] = useAppSelector(
    (state) => state.AppraisalAssets.data
  );
  const submitEvent: boolean = useAppSelector(
    (state) => state.AppraisalSubmitEvent.data
  );
  const [currencySymbol, setCurrencySymbol] = useState<string>("");

    useEffect(() => {
      setIsSubmit(submitEvent);
    }, [submitEvent]);

  useEffect(() => {
    if (Array.isArray(assets)) {
      var tempAssets = [...assets];
      tempAssets.forEach((asset: AppraisalAssetsModel, index: number) => {
        var discountRate = asset.discountRate;
        var terminalCapRate = asset.terminalCapRate;
        var impliedCapRateYr1 = asset.impliedCapRateYr1;
        var directRate = asset.directRate;
        if (asset.discountRate != null && asset.discountRate != 0 && asset.discountRate != "") {
          var a: number = Number(asset.discountRate.toString().replace(/,/g, ""));
          discountRate = a.toFixed(2)
        }
        if (asset.terminalCapRate != null && asset.terminalCapRate != 0 && asset.terminalCapRate != "") {
          var a: number = Number(asset.terminalCapRate.toString().replace(/,/g, ""));
          terminalCapRate = a.toFixed(2)
        }
        if (asset.impliedCapRateYr1 != null && asset.impliedCapRateYr1 != 0 && asset.impliedCapRateYr1 != "") {
          var a: number = Number(asset.impliedCapRateYr1.toString().replace(/,/g, ""));
          impliedCapRateYr1 = a.toFixed(2)
        }
        // if (asset.directRate != null && asset.directRate != 0 && asset.directRate != "") {
        //   var a: number = Number(asset.directRate.toString().replace(/,/g, ""));
        //   directRate = a.toFixed(2)
        // }
        tempAssets[index] = { ...asset, discountRate: discountRate, terminalCapRate: terminalCapRate, impliedCapRateYr1: impliedCapRateYr1,directRate: directRate }
      })
      setRows(tempAssets);
    }

  }, [assets]);


  useEffect(() => {
    if (appraisalDetails !== appraisalDetails as {} || appraisalDetails.currencySelected != "") {
      if (appraisalDetails.currencySelected != "ZH") {
        setCurrencySymbol(
          currencySymbolMap(appraisalDetails.currencySelected) as string
        );
      } else {
        setCurrencySymbol("ZH");
      }
    } else {
      setCurrencySymbol(currencySymbolMap("USD") as string)
    }

    // if(rows.length === 1){
    //   var localAssets:AppraisalAssetsModel[] = [...rows];
    //   localAssets[0] = {...localAssets[0],currentAppraisalValue:appraisalDetails.currentAppraisalValue};
    //   dispatch(updateAppraisalAssets(localAssets));
    // }
  }, [appraisalDetails]);

  const formatNumberWithCommas = (num: number | string | null) => {
    if (num != null)
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return '';
  }

  const handleDirectRate = (value: any, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);    
      var tempRows: AppraisalAssetsModel[] = [...rows];
      tempRows[i] = { ...tempRows[i], directRate : plainNumber };
      setRows(tempRows);
      dispatch(updateAppraisalAssets(tempRows));
    }
  }

  const handleCurrentAppraisalValueChange = (value: string, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      const tempRows: AppraisalAssetsModel[] = [...rows];
      tempRows[i] = { ...rows[i], currentAppraisalValue: formatedValue };
      setRows(tempRows);
      dispatch(updateAppraisalAssets(tempRows));
    }
  }

  const handLastAppraisedValueChange = (value: string, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      const tempRows: AppraisalAssetsModel[] = [...rows];
      tempRows[i] = { ...rows[i], lastAppraisedValue: formatedValue };
      setRows(tempRows);
      dispatch(updateAppraisalAssets(tempRows));
    }
  }

  const handleLastAnnualAppraisedValueChange = (value: string, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
      const tempRows: AppraisalAssetsModel[] = [...rows];
      tempRows[i] = { ...rows[i], lastAnnualAppraisedValue: formatedValue };
      setRows(tempRows);
      dispatch(updateAppraisalAssets(tempRows));
    }
  }
  return (
    <Box sx={{overflowX:'auto'}}>
      <TableContainer component={Paper}>
        <Table
          className="appraisal-assets-list-table">
          <TableHead>
            <TableRow>
              <TableCell align="center" colSpan={3}></TableCell>
              <TableCell align="center" colSpan={4}>
                AE DCF Model
              </TableCell>
              <TableCell align="center" colSpan={3}>
                Appraisal
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Asset ID </TableCell>
              <TableCell>Asset</TableCell>
              <TableCell>Direct Rate  <span style={{color:'red'}}>*</span></TableCell>
              <TableCell>DCF value </TableCell>
              <TableCell>Discount Rate </TableCell>
              <TableCell>Terminal Cap Rate </TableCell>
              <TableCell>Implied Cap Rate Yr 1 </TableCell>
              <TableCell>Current Value  <span style={{color:'red'}}>*</span></TableCell>
              <TableCell>Previous</TableCell>
              <TableCell>Past Year</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((asset: AppraisalAssetsModel, index: any) => (
              <TableRow>
                <TableCell sx={{minWidth:'200px'}}>{asset.id}</TableCell>
                <TableCell sx={{minWidth:'250px'}}>{asset.name}</TableCell>
                <TableCell sx={{minWidth:'200px'}}>
                  <FormControl size="small">
                  <OutlinedInput
                      id="DirectRate"
                      readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                      value={asset.directRate}
                      error={isSubmit && (asset.directRate == null || asset.directRate === "")}
                      onChange={(e) => {handleDirectRate(e.target.value,index)}}
                      startAdornment={
                        <InputAdornment position="start">%</InputAdornment>
                      }
                    />
                  </FormControl>
                </TableCell>

                <TableCell sx={{minWidth:'250px'}}>
                  <FormControl size="small">
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      readOnly
                      type="text"
                      className="Autopopulatefield"
                      value={formatNumberWithCommas(asset.dcfValue)}
                      startAdornment={
                        <InputAdornment position="start">
                          {currencySymbol}
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </TableCell>
                <TableCell sx={{minWidth:'200px'}}>
                  <FormControl size="small">
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      readOnly
                      className="Autopopulatefield"
                      value={asset.discountRate}
                      startAdornment={
                        <InputAdornment position="start">%</InputAdornment>
                      }
                    />
                  </FormControl>
                </TableCell>
                <TableCell sx={{minWidth:'200px'}}>
                  <FormControl size="small">
                    <OutlinedInput
                      id="terminalCapRate"
                      readOnly
                      className="Autopopulatefield"
                      value={asset.terminalCapRate}
                      startAdornment={
                        <InputAdornment position="start">%</InputAdornment>
                      }
                    />
                  </FormControl>
                </TableCell>
                <TableCell sx={{minWidth:'200px'}}>
                  <FormControl size="small">
                    <OutlinedInput
                      id="outlined-adornment-amount"
                      readOnly
                      className="Autopopulatefield"
                      value={asset.impliedCapRateYr1}
                      startAdornment={
                        <InputAdornment position="start">%</InputAdornment>
                      }
                    />
                  </FormControl>
                </TableCell>
                <TableCell sx={{minWidth:'250px'}}>
                  <FormControl size="small">
                    <OutlinedInput
                      id="CurrentAppraisalValue"
                      type="text"
                      value={formatNumberWithCommas(asset.currentAppraisalValue)}
                      readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                      onChange={(e) => handleCurrentAppraisalValueChange(e.target.value, index)}
                      error={isSubmit && (asset.currentAppraisalValue == null || asset.currentAppraisalValue === "")}
                      startAdornment={
                        <InputAdornment position="start">
                          {currencySymbol}
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </TableCell>
                <TableCell sx={{minWidth:'250px'}}>
                  <FormControl size="small">
                    <OutlinedInput
                      id="lastAppraisedValue"
                      readOnly = {!props.postEditForAdmin}
                      type="text"
                      className="Autopopulatefield"
                      value={formatNumberWithCommas(asset.lastAppraisedValue)}
                      onChange={(e) => handLastAppraisedValueChange(e.target.value, index)}
                      startAdornment={
                        <InputAdornment position="start">
                          {currencySymbol}
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </TableCell>
                <TableCell sx={{minWidth:'250px'}}>
                  <FormControl size="small">
                    <OutlinedInput
                      id="lastAnnualAppraisedValue"
                      readOnly = {!props.postEditForAdmin}
                      type="text"
                      className="Autopopulatefield"
                      value={formatNumberWithCommas(asset.lastAnnualAppraisedValue)}
                      onChange={(e) => handleLastAnnualAppraisedValueChange(e.target.value, index)}
                      startAdornment={
                        <InputAdornment position="start">
                          {currencySymbol}
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </TableCell>
              </TableRow>
            ))}

          </TableBody>
          {rows.length === 0 &&

            <TableFooter>
              <TableRow><TableCell align="center" colSpan={10}><p className="EmptyGrid">No historical data</p></TableCell></TableRow>
            </TableFooter>
          }
        </Table>
      </TableContainer>
    </Box>
  );
};
